<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-combobox
          md4
          max-width="200"
          v-model="main_store"
          :items="stores"
          item-text="name"
          solo
          dense
          prepend-inner-icon="mdi-store"
          return-object
        />
        <v-crud-card
          toSupplier="/partition/valuation/data"
          :headers="headers"
          :data="partition_valuation"
          v-model="partition_val_page"
          :num-pages="partition_val_total"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          @rowClicked="rowClick"
          noDelete
          :no-data-text="no_data_text"
        >
          <template #search>
            <v-spacer />
            <v-btn icon @click="downloadResult">
              <v-icon> mdi-download </v-icon>
            </v-btn>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title v-if="wait">Iltimos, kutib turing!</v-card-title>
                <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    color="primary"
                    @click="saveExcel"
                    :disabled="wait"
                  >
                    <export-excel :data="downExcel" :name="excel_name"
                      >Save Excel</export-excel
                    >
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="proccesDialog" max-width="400px">
              <v-card>
                <v-list-item-action style="width: 338px; padding-left: 40px">
                  <v-progress-linear
                    :color="
                      excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'
                    "
                    background-color="white"
                    height="10"
                    style="border: 1px solid rgba(0, 0, 0, 0.26)"
                    v-bind:value="excel_dowload_proccess"
                    striped
                  />
                  <v-list-item-action-text
                    >{{ $t("download") }}
                    {{ excel_dowload_proccess.toFixed() + " %" }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-card>
            </v-dialog>
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                autofocus
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), getPartions();
                  }
                "
                @change="getPartions()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-menu min-width="200" left offset-y>
              <template #activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list class="py-2 px-4">
                <v-list-item
                  @click="
                    (sort_type = sort_type === 1 ? -1 : 1),
                      (sort_by = 'supplier_name')
                  "
                >
                  <v-list-item-title>
                    <span>{{ $t(`name`) }}</span>
                    <v-icon
                      v-if="sort_type === 1 && sort_by === 'supplier_name'"
                      >mdi-arrow-up</v-icon
                    >
                    <v-icon
                      v-if="sort_type === -1 && sort_by === 'supplier_name'"
                      >mdi-arrow-down</v-icon
                    >
                  </v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="(sort_type = sort_type === 1 ? -1 : 1), (sort_by = 'quantity')">
                  <v-list-item-title>
                    <span>{{ $t(`quantity`) }}</span>
                    <v-icon v-if="sort_type === 1 && sort_by === 'quantity'">mdi-arrow-up</v-icon>
                    <v-icon v-if="sort_type === -1 && sort_by === 'namquantitye'">mdi-arrow-down</v-icon>  
                  </v-list-item-title>
                </v-list-item> -->
                <!-- <v-list-item @click="(sort_type = sort_type === 1 ? -1 : 1), (sort_by = 'quantity_left')">
                  <v-list-item-title>
                    <span>{{ $t(`quantity_left`) }}</span>
                    <v-icon v-if="sort_type === 1 && sort_by === 'quantity_left'">mdi-arrow-up</v-icon>
                    <v-icon v-if="sort_type === -1 && sort_by === 'quantity_left'">mdi-arrow-down</v-icon>
                  </v-list-item-title>
                </v-list-item> -->
                <v-list-item
                  @click="
                    (sort_type = sort_type === 1 ? -1 : 1),
                      (sort_by = 'total_cost')
                  "
                >
                  <v-list-item-title>
                    <span>{{ $t(`total_cost`) }}</span>
                    <v-icon v-if="sort_type === 1 && sort_by === 'total_cost'"
                      >mdi-arrow-up</v-icon
                    >
                    <v-icon v-if="sort_type === -1 && sort_by === 'total_cost'"
                      >mdi-arrow-down</v-icon
                    >
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="sort_by = ''">
                  <v-list-item-title>
                    <v-btn color="primary">Refresh</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>

<script>
import Services from "../../mixins/services";
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  data: () => ({
    partition_valuation: [],
    main_store: {
      name: "All stores",
      _id: "",
    },
    partition_val_page: 1,
    partition_val_total: 0,
    data_loading: false,
    no_data_text: "No data available",
    access: "",
    search_text: false,
    search: "",
    searchText: "",
    searchService: "",
    sort_by: "",
    sort_type: 1,
    downExcel: [],
    excel_name: "Partitionvaluation",
    dialog: false,
    wait: true,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  mixins: [Services],
  computed: {
    headers() {
      return [
        {
          value: "supplier_name",
          text: this.$t("supplier_name"),
          available: true,
        },
        {
          value: "phone_number",
          text: this.$t("phone_number"),
          available: true,
        },
        // { value: "quantity", text: this.$t("quantity") },
        // { value: "quantity_left", text: this.$t("quantity_left") },
        { value: "total_cost", text: this.$t("cost"), available: true },
      ];
    },
  },
  methods: {
    rowClick(item) {
      this.$store.state.partition_valuation_by_supplier = item._id;
    },
    changePagination(page) {
      this.partition_val_page = page;
    },
    async getData() {
      this.data_loading = true;
      const result = await this.$communicator("partition_valuation", {
        params: {
          limit: 10,
          page: this.partition_val_page,
          service_id: this.main_store._id,
          search: this.search,
          sort_by: this.sort_by,
          sort_type: this.sort_type,
        },
      });
      if (result) this.data_loading = false;
      if (result.statusCode === 422) {
        this.no_data_text = "Access denied";
        this.partition_valuation = [];
      }
      this.partition_valuation = result?.data?.data?.data;
      this.partition_val_total = Math.ceil(result?.data?.data?.total / 10);
      this.max_total = result?.data?.data?.total;
    },
    searchActivate() {
      this.search = "";
      this.search_text = true;
    },
    getPartions(pageChanged) {
      if (this.searchText === this.search && !pageChanged) {
        return;
      }
      this.getData();
      this.searchText = this.search;
    },
    async downloadResult() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const limit = 100;
      let all_data = [];
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const partition = await this.$communicator("partition_valuation", {
          params: {
            limit: limit,
            page: page,
            service_id: this.main_store._id,
            search: this.search,
          },
        });
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...partition?.data?.data?.data);
      }
      const result = await all_data.map((sup) => ({
        supplier_name: sup.supplier_name,
        phone_number: sup.phone_number,
        cost: sup.total_cost,
      }));
      this.proccesDialog = false;
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "PartionValuation.xlsx");
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },
  },
  watch: {
    partition_val_page() {
      this.getData();
    },
    main_store() {
      this.getData();
    },
    sort_by() {
      this.getData();
    },
    sort_type() {
      this.getData();
    },
  },
  beforeMount() {
    this.getData();
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
</style>
